import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  InputGroup,
  Button,
  Breadcrumb,
  Pagination,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import PopUpCreateDepositAndWithdraw from "../../components/popup/PopUpCreateDepositAndWithdraw";
import PopUpConfirmDepositAndWithdraw from "../../components/popup/PopUpConfirmDepositAndWithdraw";
import { SuccessSwal } from "../../helpers/alertseet";
import {
  add_deposit,
  add_withdraw,
  delete_activity_history,
  get_balances,
  update_activity_history,
} from "../../services/balance.service";
import { useStore } from "../../store";
import convertTypeDepositWithdraw from "../../helpers/convertTypeDepositWithdraw";
import moment from "moment";
import convertNumber from "../../helpers/convertNumber";
import EmptyComponent from "../../components/EmptyComponent";
import LoadingComponent from "../../components/LoadingComponent";
import ReactPaginate from "react-paginate";
import { jwtDecode } from "jwt-decode";
import PopUpDetailActivityHistoryByBalance from "../../components/popup/PopUpDetailActivityHistoryByBalance";
import cutBranchNo from "../../helpers/cutBranchNo";
import addBranchNo from "../../helpers/addBranchNo";
import PopUpUpdateDepositAndWithdraw from "../../components/popup/PopUpUpdateDepositAndWithdraw";
import PopUpConfirmDelete from "../../components/popup/PopUpConfirmDelete";
import PopUpConfirmDiscretion from "../../components/popup/PopUpConfirmDiscretion";
import convertTypeActivityHistory from "../../helpers/convertTypeActivityHistory";

let limitData = 50;

export default function DepositAndWithdrawPage() {
  const navigate = useNavigate();
  // state
  const [popup, setPopup] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [balanceDataList, setBanlanceDataList] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [totalPagination, setTotalPagination] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [backupFormData, setBackupFormData] = useState(); // ສົ່ງຂໍ້ມູນເຂົ້າຟອມ
  const [formData, setFormData] = useState({});
  const [selecteBalanceDataList, setSelecteBalanceDataList] = useState();
  const [totalDataList, setTotalDataList] = useState(0);

  // store
  const { token, branchData } = useStore();

  // useEffect
  useEffect(() => {
    getData();
  }, [pagination]);

  // function
  const handleSearch = () => {
    getData();
  };
  const getData = async () => {
    try {
      setIsLoading(true);
      let findby = "?";
      findby += `skip=${(pagination - 1) * limitData}&`;
      findby += `limit=${limitData}&`;
      // findby += `memberNo=${searchInput}&`;
      if (searchInput) {
        findby += `memberNo=${addBranchNo(searchInput, branchData?.branchNo)}&`;
      }

      const data = await get_balances(findby, token);
      if (data?.error) throw new Error(data?.message);
      let banlance = data?.data;
      setTotalDataList(data?.total);
      setTotalPagination(Math.ceil(data?.total / limitData));
      setBanlanceDataList(banlance);
      console.log("banlance: ", banlance);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const handleCreateDepositAndWithdraw = async (data) => {
    const decoded = jwtDecode(token);
    console.log("decoded", decoded);
    setFormData((prev) => ({ ...prev, ...data, branchId: decoded?.branchId }));
    setPopup({ PopUpConfirmDepositAndWithdraw: true });
  };
  const handleUpdateActivityHistor = async (data) => {
    // DONE: ຟັງຊັ້ນອັບດເດຂໍ້ມູນ activityHistory
    try {
      await update_activity_history(data?._id, data, token);
      setPopup();
      getData();
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const handleConfirmDepositAndWithdraw = async () => {
    try {
      let _res;
      const decoded = jwtDecode(token);
      if (formData?.type === "DEPOSIT") {
        _res = await add_deposit(
          formData?.memberId,
          { ...formData, branchId: decoded?.branchId },
          token
        );
      } else if (formData?.type === "WITHDRAW") {
        _res = await add_withdraw(
          formData?.memberId,
          { ...formData, branchId: decoded?.branchId },
          token
        );
      } else {
        throw new Error("ມີບາງຢາງຜິດພາດ");
      }
      if (_res?.error) throw new Error("ມີບາງຢ່າງຜິດພາດ");

      setFormData({});
      setBackupFormData();
      getData();
      setPopup();
    } catch (err) {
      console.error(err);
    }
  };
  const handleDeleteActivityHistory = async (activityId) => {
    // DONE: ລົບ activity history
    const _data = await delete_activity_history(activityId, token);
    setPopup();
    setSelecteBalanceDataList();
    if (!_data.error) {
      getData();
    }

    // navigate("/deposit-and-withdraw", { replace: true });
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item active>ອອມ ແລະ ຖອນ</Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: 16,
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 100,
        }}
      >
        <h2>ຕາຕະລາງບັນຊີເງິນອອມ ແລະ ຖອນ</h2>
        <div
          style={{
            display: "flex",
            gap: 20,
            alignItems: "flex-end",
            marginBottom: 16,
          }}
        >
          <div>
            <label>ຄົ້ນຫາ</label>
            <InputGroup style={{ maxWidth: 230 }}>
              <Form.Control
                placeholder="ປ້ອນເລກສະມາຊິກ"
                style={{ paddingLeft: 10 }}
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <Button
                style={{ width: 40, padding: 0 }}
                onClick={() => handleSearch()}
              >
                <Icon icon="tabler:search" style={{ width: 20, height: 20 }} />
              </Button>
            </InputGroup>
          </div>
          <div style={{ flex: 1 }}></div>
          <div>
            <Button
              onClick={() => {
                setPopup({ PopUpCreateDepositAndWithdraw: true });
              }}
              size="md"
            >
              ສ້າງລາຍການ
            </Button>
          </div>
        </div>
        {/* loading */}
        <div
          style={{
            width: "100%",
            display: isLoading ? "flex" : "none",
            justifyContent: "center",
            padding: 20,
            height: 400,
            alignItems: "center",
          }}
        >
          <LoadingComponent />
        </div>
        <div
          style={{
            width: "100%",
            display:
              balanceDataList?.length === 0 && !isLoading ? "flex" : "none",
            justifyContent: "center",
            padding: 20,
            height: 400,
            alignItems: "center",
          }}
        >
          <EmptyComponent />
        </div>
        {/*  */}
        <div
          style={{
            color: "#6c757d",
            fontSize: 14,
            fontWeight: 700,
            padding: "0px 10px",
            display: !isLoading ? "block" : "none",
          }}
        >
          ທັງໝົດ {totalDataList} ລາຍການ
        </div>
        <div
          style={{
            overflow: "auto",
            display:
              balanceDataList?.length > 0 && !isLoading ? "block" : "none",
          }}
        >
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ລະຫັດລາຍການ</th>
                <th>ເລກສະມາຊິກ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <th>ສະຖານະ</th>
                <th style={{ textAlign: "end" }}>ທຸລະກຳ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ຍອດຍັງເຫຼືອ (ກີບ)</th>
                <th>ປະເພດ</th>
                <th>ວັນທີເຄື່ອນໄຫວ</th>
                <th>ຜູ້ສ້າງລາຍການ</th>
              </tr>
            </thead>
            <tbody>
              {/* DONE: ປະຫວັດການແກ້ໄຂ*/}
              {/* DONE: ປະຫວັດການລົບ */}
              {balanceDataList?.map((e, i) => (
                <tr
                  onClick={() => {
                    setSelecteBalanceDataList(e);
                    setPopup({ PopUpDetailActivityHistoryByBalance: true });
                  }}
                  className="hover"
                  style={{ color: e?.isDelete ? "#CED4DA" : "#343A40" }}
                  key={i}
                >
                  <td>{e?.activityHistoryNo || "-"}</td>
                  <td>
                    {e?.memberId?.memberNo
                      ? cutBranchNo(e?.memberId?.memberNo)
                      : "-"}
                  </td>
                  <td>
                    <div>
                      {e?.memberId?.fullName || "-"}
                    </div>
                    {e?.memberId?.isDelete ? <div style={{fontSize: 14, color: "red"}}>ຍົກເລີກການເປັນສະມາຊິກແລ້ວ</div> : <div />}
                  </td>
                  <td>{convertTypeDepositWithdraw(e?.activityHistoryType)}</td>
                  <td
                    style={{
                      textAlign: "end",
                      color: e?.isDelete
                        ? "#CED4DA"
                        : e?.activityHistoryType != "WITHDRAW"
                          ? "#0DCD5A"
                          : "#FF0000",
                    }}
                  >
                    {e?.activityHistoryType != "WITHDRAW" ? "+" : "-"}
                    {e?.balanceAmount ? convertNumber(e?.balanceAmount) : "-"}
                  </td>
                  <td style={{ textAlign: "end" }}>
                    {e?.currentTotalBalance
                      ? convertNumber(e?.currentTotalBalance)
                      : "-"}
                  </td>
                  <td>
                    <div>
                      {e?.activityManagementType
                        ? convertTypeActivityHistory(e?.activityManagementType)
                        : "-"}
                    </div>
                  </td>
                  <td>
                    {e?.updatedAt
                      ? moment(e?.updatedAt).format("DD/MM/YYYY HH:mm")
                      : "-"}
                  </td>
                  <td>{e?.createdBy?.fullName || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            width: "100%",
            bottom: 20,
          }}
        >
          <ReactPaginate
            previousLabel={
              <span className="glyphicon glyphicon-chevron-left">{`<`}</span>
            }
            nextLabel={
              <span className="glyphicon glyphicon-chevron-right">{`>`}</span>
            }
            breakLabel={<Pagination.Item disabled>...</Pagination.Item>}
            breakClassName={"break-me"}
            pageCount={totalPagination} // Replace with the actual number of pages
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={(e) => {
              console.log(e);
              setPagination(e?.selected + 1);
            }}
            containerClassName={"pagination justify-content-center"} // Bootstrap class for centering
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
          />
        </div>
      </Card>
      {/* ------------------------------------------------------------------------------------- popup ------------------------------------------------------------------------------------- */}
      <PopUpCreateDepositAndWithdraw
        open={popup?.PopUpCreateDepositAndWithdraw}
        onClose={() => setPopup()}
        setPopup={setPopup}
        popup={popup}
        onSubmit={handleCreateDepositAndWithdraw}
        backupFormData={backupFormData}
        setBackupFormData={setBackupFormData}
      />
      <PopUpConfirmDepositAndWithdraw
        open={popup?.PopUpConfirmDepositAndWithdraw}
        formData={formData}
        onClose={() => {
          setPopup({ PopUpCreateDepositAndWithdraw: true });
        }}
        onSubmit={handleConfirmDepositAndWithdraw}
      />
      <PopUpDetailActivityHistoryByBalance
        open={popup?.PopUpDetailActivityHistoryByBalance}
        onClose={() => {
          setPopup();
          setSelecteBalanceDataList();
        }}
        data={selecteBalanceDataList}
        onClickEdit={() => {
          setPopup({ PopUpUpdateDepositAndWithdraw: true });
        }}
        onClickDelete={() => {
          setPopup({
            PopUpConfirmDelete: true,
          });
        }}
      />
      <PopUpUpdateDepositAndWithdraw
        open={popup?.PopUpUpdateDepositAndWithdraw}
        onClose={() => {
          setPopup();
          setSelecteBalanceDataList();
        }}
        setPopup={setPopup}
        popup={popup}
        onSubmit={handleUpdateActivityHistor}
        activityHistoryId={selecteBalanceDataList?._id}
        backupFormData={backupFormData}
        setBackupFormData={setBackupFormData}
      />

      <PopUpConfirmDelete
        open={popup?.PopUpConfirmDelete}
        title="ລຶບທຸລະກຳ!"
        onClose={() => {
          setPopup();
          setSelecteBalanceDataList();
        }}
        onSubmit={() =>
          handleDeleteActivityHistory(selecteBalanceDataList?._id)
        }
        sub={
          <div>
            <div>ທ່ານຕ້ອງການລຶບທຸລະກຳນີ້ບໍ</div>
            <div style={{ fontWeight: 700, textAlign: "center" }}>
              {selecteBalanceDataList?.memberId?.fullName || "-"}{" "}
              {convertTypeDepositWithdraw(
                selecteBalanceDataList?.activityHistoryType
              )}{" "}
              <span
                style={{
                  color:
                    selecteBalanceDataList?.activityHistoryType != "WITHDRAW"
                      ? "#0DCD5A"
                      : "#FF0000",
                }}
              >
                {selecteBalanceDataList?.activityHistoryType != "WITHDRAW"
                  ? "+"
                  : "-"}
                {selecteBalanceDataList?.balanceAmount
                  ? convertNumber(selecteBalanceDataList?.balanceAmount)
                  : "-"}
              </span>{" "}
              ກີບ
            </div>
          </div>
        }
      />
      <PopUpConfirmDiscretion //for create activity history
        open={popup?.PopUpConfirmDiscretion_for_create}
        onClose={() => {
          setPopup({ PopUpCreateDepositAndWithdraw: true });
        }}
        onSubmit={() => {
          setBackupFormData((prev) => ({
            ...prev,
            formData: { ...prev?.formData, manualCheck: true },
          }));
          setPopup({ PopUpCreateDepositAndWithdraw: true });
        }}
      />
      <PopUpConfirmDiscretion //for updata activity history
        open={popup?.PopUpConfirmDiscretion_for_update}
        onClose={() => {
          setPopup({ PopUpUpdateDepositAndWithdraw: true });
        }}
        onSubmit={() => {
          setBackupFormData((prev) => ({
            ...prev,
            formData: { ...prev?.formData, manualCheck: true },
          }));
          setPopup({ PopUpUpdateDepositAndWithdraw: true });
        }}
      />
    </div>
  );
}
